<template>
  <b-card title="Subscription">
    <b-alert show variant="warning" class="mb-2">
      <div class="alert-body">
        <feather-icon icon="AlertCircleIcon" class="mr-50" />
        <strong>This page is currently being attended to.</strong>
        To subscribe or renew, please contact the admin to make payments.
      </div>
    </b-alert>

    <b-row class="justify-content-center">
      <b-col md="6" lg="5">
        <!-- Subscribed State Display -->
        <b-card v-if="isSubscribed" class="popular" align="center">
          <b-avatar class="mb-1" size="30px" variant="light-success">
            <feather-icon size="20px" icon="CheckCircleIcon" />
          </b-avatar>
          <h3>Lenon Ghana</h3>
          <strong :class="isFreemium ? 'text-warning' : 'text-success'">
            {{ isFreemium ? 'FREEMIUM' : 'SUBSCRIBED' }}
          </strong>

          <b-card-text class="mt-2">
            <div v-if="isFreemium" class="text-muted mb-2">
              You are currently using a limited version of Lenon with Ads.
            </div>
            <div v-else class="text-muted mb-2">
              You are currently subscribed on Lenon Ghana.
            </div>

            <div class="subscription-details text-left mt-2">
              <div class="d-flex justify-content-between mb-1 py-1 border-bottom">
                <span>Total Students:</span>
                <strong>{{ subscriptionStudents }}</strong>
              </div>
              <div v-if="!isFreemium" class="d-flex justify-content-between mb-1 py-1 border-bottom">
                <span>Days Left:</span>
                <strong :class="daysLeft <= 7 ? 'text-danger' : 'text-success'">{{ daysLeft }}</strong>
              </div>
              <div v-if="!isFreemium" class="d-flex justify-content-between mb-1 py-1 border-bottom">
                <span>Ends On:</span>
                <strong>{{ subscriptionEndDate }}</strong>
              </div>
            </div>
          </b-card-text>

          <p class="text-muted mt-2 mb-0">
            Online payments are temporarily unavailable. Contact admin to subscribe or renew.
          </p>
        </b-card>

        <!-- Unsubscribed / Plan Info -->
        <b-card v-else class="popular" align="center">
          <b-avatar class="mb-1" size="30px" variant="light-success">
            <feather-icon size="20px" icon="CheckCircleIcon" />
          </b-avatar>
          <h3>Lenon Ghana</h3>
          <strong>Subscription Plan</strong>

          <b-card-text class="mt-1">
            <div class="pricing-info mb-2">
              <div class="d-flex justify-content-center align-items-center">
                <span class="font-weight-bold text-primary h2 mb-0">GHS 5</span>
                <span class="ml-1">per student per term</span>
              </div>
              <small class="text-muted">(1 Term = 4 Months)</small>
            </div>
          </b-card-text>

          <p class="text-muted mt-2 mb-0">
            Online payments are temporarily unavailable. Please contact the admin to make payments and subscribe.
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BAvatar, BAlert,
} from 'bootstrap-vue'
import showToast from '@/lenon/mixins/showToast'

export default {
  components: {
    BCardText,
    BRow,
    BCol,
    BCard,
    BAvatar,
    BAlert,
  },
  mixins: [showToast],
  computed: {
    subscription() {
      return this.$store.getters['auth/subscription'] || {}
    },
    isSubscribed() {
      return this.subscription.subscribed || this.subscription.freemium
    },
    isFreemium() {
      return this.subscription.freemium
    },
    daysLeft() {
      return this.subscription.days_left || 0
    },
    subscriptionEndDate() {
      return this.subscription.ends || 'N/A'
    },
    subscriptionStudents() {
      return this.$store.getters['auth/totalStudents'] || 0
    },
  },
  created() {
    this.getCurrentSub()
  },
  methods: {
    getCurrentSub() {
      this.$http.get('accounts/current-subscription')
        .then(res => {
          this.modules = res.data?.modules
          this.$store.commit('auth/setSubAndPricing', res.data?.subscription)
        })
        .catch(() => {
          this.showError('Failed to load subscription')
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
